
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#245389","data-name":"vuesax/twotone/frame"}},[_c('path',{attrs:{"d":"M12.709 18.542H7.284c-2.083 0-3.492-.443-4.447-1.395S1.442 14.783 1.442 12.7v-.108a6.365 6.365 0 011.11-4.127 4.941 4.941 0 013.615-1.662.625.625 0 01.68.564.625.625 0 01-.564.68 3.734 3.734 0 00-2.755 1.195 5.312 5.312 0 00-.836 3.35v.108c0 1.73.327 2.862 1.028 3.564s1.834 1.028 3.564 1.028h5.425c1.729 0 2.862-.327 3.563-1.028S17.3 14.43 17.3 12.701v-.109a5.288 5.288 0 00-.848-3.362 3.793 3.793 0 00-2.805-1.188.625.625 0 01-.569-.676.625.625 0 01.676-.569c3.317.286 4.8 2.074 4.8 5.8v.108c0 2.083-.443 3.5-1.395 4.447s-2.367 1.39-4.45 1.39z"}}),_c('g',{attrs:{"data-name":"Group 654","opacity":".4"}},[_c('path',{attrs:{"data-name":"Vector","d":"M10 1.976a.625.625 0 00-.625.625v10.733a.625.625 0 00.625.625.625.625 0 00.625-.625V2.601A.625.625 0 0010 1.976z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.001 1.042a.623.623 0 00-.442.183L6.767 4.017a.625.625 0 000 .884.625.625 0 00.884 0l2.35-2.35 2.35 2.35a.625.625 0 10.883-.884l-2.792-2.792a.623.623 0 00-.441-.183z"}})])])])
          )
        }
      }
    